export const BILLING_CYCLE_MONTHLY = 'monthly' as const;
export const BILLING_CYCLE_YEARLY = 'yearly' as const;

export const CHECKOUT_STATE_IDLE = 'IDLE' as const;
export const CHECKOUT_STATE_FETCHING_ORDER = 'FETCHING_ORDER' as const;
export const CHECKOUT_STATE_ORDER_READY = 'ORDER_READY' as const;
export const CHECKOUT_STATE_PAYMENT_PROCESSING = 'PAYMENT_PROCESSING' as const;
export const CHECKOUT_STATE_VERIFYING = 'VERIFYING' as const;
export const CHECKOUT_STATE_PAYMENT_PENDING = 'PAYMENT_PENDING' as const;
export const CHECKOUT_STATE_AWAITING_WEBHOOK = 'AWAITING_WEBHOOK' as const;
export const CHECKOUT_STATE_SUCCESS = 'SUCCESS' as const;
export const CHECKOUT_STATE_FAILED = 'FAILED' as const;
export const CHECKOUT_STATE_DISMISSED = 'DISMISSED' as const;

export const BILLING_PAGE_SIZE = 10;
export const BILLING_HISTORY_PREFETCH_SIZE = 250;
export const COUPON_DEBOUNCE_MS = 400;
export const COUPON_CODE_MAX_LEN = 30;

export const WEBHOOK_POLL_INTERVAL_MS = 5_000;
// 8 minutes: Razorpay webhooks can be delayed during outages or high load.
// 2 minutes was too aggressive and caused false "timeout" errors on valid payments.
export const WEBHOOK_POLL_TIMEOUT_MS = 8 * 60_000;
// How long a pending confirmation in sessionStorage is considered valid.
// If the user returns to the billing page after this window, we do one immediate
// status fetch instead of re-starting the full "awaiting" countdown.
export const PENDING_CONFIRMATION_MAX_AGE_MS = 30 * 60_000;

export const PRORATION_LARGE_CHARGE_THRESHOLD_INR = 5_000;

export const CURRENCY_INR = 'INR' as const;

export const RAZORPAY_CHECKOUT_BRAND_NAME = 'Zopeo';
export const RAZORPAY_CHECKOUT_DESCRIPTION = 'Subscription payment authorization';
